import script from "./WegowInput.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowInput.vue?vue&type=script&setup=true&lang=js"

import "./WegowInput.vue?vue&type=style&index=0&id=adb4c370&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adb4c370"]])

export default __exports__